export const ARTICLE_FILTER_FIELDS = [
  {
    type: 'text',
    name: 'title',
    label: 'Title',
    value: ''
  },
  {
    type: 'dropdown',
    name: 'published',
    label: 'Published',
    value: '',
    options: [
      {
        text: 'Yes',
        value: '1'
      },
      {
        text: 'No',
        value: '0'
      }
    ]
  },
  {
    type: 'dropdown',
    name: 'article_category_uuid',
    label: 'Category',
    value: '',
    apiUrl: 'article-categories/list?fields=uuid,name',
  },
  {
    type: 'dropdown',
    name: 'article_tag_uuid',
    label: 'Tag',
    value: '',
    apiUrl: 'tags'
  },
];
